import React from 'react'
import { Route } from 'react-router-dom'
import { auth } from '../../../services/util/auth.service'
import { FiscalPermissions } from '../../../services/permission/menus'
import { ROTAS_FISCAL } from '../../../constants/fiscal'
import FiscalMenu from './FiscalMenu/FiscalMenu'
import GestaoNfse from './GestaoNfse/GestaoNfse'

export default function Fiscal() {
  return (
    <>
      <Route path={ROTAS_FISCAL.MENU} render={() => auth(<FiscalMenu />)} />
      <Route
        path={ROTAS_FISCAL.GESTAO_NFSE}
        render={() => auth(<GestaoNfse />, FiscalPermissions.GESTAO_NFSE)}
      />
    </>
  )
}
